webpackJsonp([43343626275220],{

/***/ 279:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"line":"src-components-StudentList----StudentList-module---line---VHls4","row":"src-components-StudentList----StudentList-module---row---OGJsh","lineBetween":"src-components-StudentList----StudentList-module---lineBetween---2iUbP","collaborator_name":"src-components-StudentList----StudentList-module---collaborator_name---381aC","collaborator_details":"src-components-StudentList----StudentList-module---collaborator_details---a8E43","graduation_date":"src-components-StudentList----StudentList-module---graduation_date---14hkp"};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StudentListModule = __webpack_require__(279);
	
	var _StudentListModule2 = _interopRequireDefault(_StudentListModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderItems = function renderItems() {
		var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		return array.map(function (_ref, i) {
			var node = _ref.node;
	
			return _react2.default.createElement(
				"div",
				{
					key: "list-" + i,
					className: "row justify-content-between pb-4 pb-md-0"
				},
				_react2.default.createElement(
					"div",
					{ className: "col-12 col-md-4 col-lg-3" },
					_react2.default.createElement(
						"div",
						{ className: _StudentListModule2.default.row },
						_react2.default.createElement(
							"div",
							{ className: _StudentListModule2.default.line },
							_react2.default.createElement(
								"b",
								{ className: _StudentListModule2.default.collaborator_name },
								node.title + " " + node.name
							),
							node.isAlumni && _react2.default.createElement(
								"b",
								{ className: _StudentListModule2.default.graduation_date },
								node.node_locale === "th" ? "จบการศึกษาปีพ.ศ." : "Graduated in ",
								node.graduationYear
							)
						)
					)
				),
				_react2.default.createElement("div", { className: _StudentListModule2.default.lineBetween }),
				_react2.default.createElement(
					"div",
					{ className: "col-12 col-md-7 col-lg-8 " + _StudentListModule2.default.line },
					node.isAlumni ? _react2.default.createElement(
						"span",
						{ className: "pb-md-2" },
						_react2.default.createElement(
							"span",
							{ style: { fontWeight: "bold" } },
							"Final thesis:",
							" "
						),
						" ",
						node.finalThesis && node.finalThesis.content
					) : node.researchSubject && node.researchSubject.content,
					node.currentPosition && node.currentPosition && node.currentPosition.content !== "-" && _react2.default.createElement(
						"span",
						null,
						_react2.default.createElement(
							"span",
							{ style: { fontWeight: "bold" } },
							node.node_locale === "th" ? "ตำแหน่งงานปัจจุบัน: " : "Current position: "
						),
						node.currentPosition && node.currentPosition.content
					)
				)
			);
		});
	};
	
	var StudentList = function StudentList(props) {
		return _react2.default.createElement(
			"div",
			{ className: props.className },
			renderItems(props.list)
		);
	};
	
	exports.default = StudentList;
	module.exports = exports["default"];

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(115);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _studyWithUsModule = __webpack_require__(129);
	
	var _studyWithUsModule2 = _interopRequireDefault(_studyWithUsModule);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkup(value) {
		return {
			__html: value
		};
	}
	var StudyWithUs = function StudyWithUs(_ref) {
		var style = _ref.style,
		    title = _ref.title,
		    featuredImage = _ref.featuredImage,
		    description = _ref.description;
		return _react2.default.createElement(
			"div",
			{ className: _studyWithUsModule2.default.outer_wrapper, style: style },
			_react2.default.createElement(
				"div",
				{ className: "container" },
				_react2.default.createElement(
					"div",
					{ className: "row justify-content-center justify-content-lg-between " + _studyWithUsModule2.default.row },
					_react2.default.createElement(
						"div",
						{ className: "col-12 col-md-8 col-lg-7 " + _studyWithUsModule2.default.featured_image },
						_react2.default.createElement(_gatsbyImage2.default, {
							title: featuredImage.title,
							alt: featuredImage.title,
							sizes: featuredImage.sizes
						})
					),
					_react2.default.createElement(
						"div",
						{ className: "col-12 col-md-12 col-lg-6 " + _studyWithUsModule2.default.featured_post },
						_react2.default.createElement(
							"h3",
							null,
							title
						),
						_react2.default.createElement("hr", { className: _studyWithUsModule2.default.hr }),
						_react2.default.createElement("span", { className: "text-dark", dangerouslySetInnerHTML: createMarkup(description) })
					)
				)
			)
		);
	};
	
	exports.default = StudyWithUs;
	module.exports = exports["default"];

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"opportunities_list":"src-components-study-with-us----study-with-us-module---opportunities_list---2FBi6","outer_wrapper":"src-components-study-with-us----study-with-us-module---outer_wrapper---1IoJM","row":"src-components-study-with-us----study-with-us-module---row---1X2Mb","featured_image":"src-components-study-with-us----study-with-us-module---featured_image---3rUB8","featured_post":"src-components-study-with-us----study-with-us-module---featured_post---304LL","hr":"src-components-study-with-us----study-with-us-module---hr---FR4Kv","featured_post_category":"src-components-study-with-us----study-with-us-module---featured_post_category---1ezqj","read_more":"src-components-study-with-us----study-with-us-module---read_more---14HmP"};

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list_title":"src-styles----students-module---list_title---3gQTI","h2":"src-styles----students-module---h2---1KJcS","tab_students":"src-styles----students-module---tab_students---2R3VW","tab_opportunities":"src-styles----students-module---tab_opportunities---3wBkW","tab_opportunities_visible":"src-styles----students-module---tab_opportunities_visible---6FQDd","tab_students_visible":"src-styles----students-module---tab_students_visible---lcCM3","opportunities_list":"src-styles----students-module---opportunities_list---2KsBW","jumbo_h1":"src-styles----students-module---jumbo_h1---3g74z","grey_wrapper":"src-styles----students-module---grey_wrapper---3VSlW","students_wrapper":"src-styles----students-module---students_wrapper---3aGz6"};

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _subNav = __webpack_require__(73);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _StudentList = __webpack_require__(239);
	
	var _StudentList2 = _interopRequireDefault(_StudentList);
	
	var _studyWithUs = __webpack_require__(118);
	
	var _studyWithUs2 = _interopRequireDefault(_studyWithUs);
	
	var _studentsModule = __webpack_require__(287);
	
	var _studentsModule2 = _interopRequireDefault(_studentsModule);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const Students = props => {
	var Students = function (_React$Component) {
		_inherits(Students, _React$Component);
	
		function Students(props) {
			_classCallCheck(this, Students);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleClick = function (category) {
				var locale = _this.props.data.contentfulResearchPage.node_locale;
				navigateTo({ pathname: "/" + locale + "/students", hash: category });
			};
	
			_this.state = {
				tab: "current"
			};
			return _this;
		}
	
		Students.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
			var props = this.props;
			var location = nextProps.location;
	
	
			if (nextState.currentCat !== this.state.currentCat) {
				return true;
			}
			return location.pathname !== props.location.pathname || location.hash !== props.location.hash;
		};
	
		Students.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var oldHashCategory = this.props.location.hash.slice(1);
			var newHashCategory = nextProps.location.hash.slice(1);
	
			if (oldHashCategory !== newHashCategory && newHashCategory.length > 0) {
				this.setState({ tab: newHashCategory });
			}
		};
	
		Students.prototype.componentDidMount = function componentDidMount() {
			var hashCategory = this.props.location.hash.slice(1);
	
			if (hashCategory.length > 0) {
				this.setState({ tab: hashCategory });
			}
		};
	
		Students.prototype.render = function render() {
			var props = this.props;
			var transition = props.transition,
			    data = props.data;
			var pageSettings = data.pageSettings,
			    cta = data.cta,
			    bottomBanner = data.bottomBanner,
			    alumMsc = data.alumMsc,
			    alumPhd = data.alumPhd,
			    currentMsc = data.currentMsc,
			    currentPhd = data.currentPhd;
	
			var workWithUs = bottomBanner.edges[0].node;
	
			var navList = [{
				label: pageSettings.node_locale === "th" ? "นักศึกษาปัจจุบัน" : "Current Students",
				name: "current",
				href: "students"
			}, {
				label: pageSettings.node_locale === "th" ? "ศิษย์เก่า" : "Alumni",
				name: "alumni",
				href: "students"
			}];
	
			return _react2.default.createElement(
				_PageWrapper2.default,
				{
					locale: pageSettings.node_locale,
					location: this.props.location,
					data: data.layout.edges[0].node
				},
				_react2.default.createElement(
					"main",
					{ role: "main", style: transition && transition.style },
					_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle + " | Mahidol Vivax Research Unit" }),
					_react2.default.createElement(
						_Jumbotron2.default,
						{
							type: "jumbotron_b",
							bottomLine: true,
							className: "mb-0",
							textAlign: "text-center",
							contentAlign: "justify-content-md-center"
						},
						_react2.default.createElement(
							"h1",
							{ className: _studentsModule2.default.jumbo_h1 },
							pageSettings.pageTitle || "Students &amp; Alumni"
						)
					),
					_react2.default.createElement(
						"div",
						{
							className: "container",
							style: { transform: "translateY(-50%)" }
						},
						_react2.default.createElement(
							"div",
							{ className: "row justify-content-center" },
							_react2.default.createElement(
								"div",
								{ className: "col-12 col-lg-10" },
								_react2.default.createElement(_subNav2.default, {
									active: this.state.tab,
									scroll: false,
									offset: -100,
									locale: pageSettings.node_locale,
									navList: navList,
									handleClick: this.handleClick
								})
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: _studentsModule2.default.grey_wrapper },
						_react2.default.createElement(
							"div",
							{
								className: " " + (this.state.tab === "current" ? _studentsModule2.default.tab_opportunities_visible : _studentsModule2.default.tab_opportunities)
							},
							_react2.default.createElement(
								"div",
								{ className: "container " + _studentsModule2.default.students_wrapper },
								currentPhd && _react2.default.createElement(
									"div",
									{ className: "white_bg py-2 pt-5 py-lg-5" },
									_react2.default.createElement(
										"div",
										{ className: "row no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h2",
												{ className: _studentsModule2.default.h2 },
												pageSettings.node_locale === "th" ? "นักศึกษาปัจจุบัน" : "Current Students"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h3",
												{ className: _studentsModule2.default.list_title },
												"Ph.D"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(_StudentList2.default, {
												list: currentPhd.edges
											})
										)
									)
								),
								currentMsc && _react2.default.createElement(
									"div",
									{ className: "white_bg pt-4 pb-5 " },
									_react2.default.createElement(
										"div",
										{ className: "row no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h3",
												{ className: _studentsModule2.default.list_title },
												"MSc."
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(_StudentList2.default, {
												list: currentMsc.edges
											})
										)
									)
								),
								!currentPhd && !currentMsc && _react2.default.createElement(
									"div",
									{ className: " mb-5" },
									_react2.default.createElement(
										"div",
										{ className: "row white_bg  no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h2",
												{ className: _studentsModule2.default.h2 },
												pageSettings.node_locale === "th" ? "ศิษย์เก่า" : "Alumni"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10 text-center" },
											_react2.default.createElement(
												"h3",
												{
													className: _studentsModule2.default.list_title
												},
												"Sorry, we haven't added any Alumni yet"
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							"div",
							{
								className: this.state.tab === "alumni" ? _studentsModule2.default.tab_students_visible : _studentsModule2.default.tab_students
							},
							_react2.default.createElement(
								"div",
								{ className: "container " + _studentsModule2.default.students_wrapper },
								alumPhd && _react2.default.createElement(
									"div",
									{ className: "white_bg py-2 pt-5 py-lg-5" },
									_react2.default.createElement(
										"div",
										{ className: "row  no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h2",
												{ className: _studentsModule2.default.h2 },
												pageSettings.node_locale === "th" ? "ศิษย์เก่า" : "Alumni"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h3",
												{ className: _studentsModule2.default.list_title },
												"Ph.D"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(_StudentList2.default, {
												list: alumPhd.edges,
												alumni: true
											})
										)
									)
								),
								alumMsc && _react2.default.createElement(
									"div",
									{ className: "white_bg pt-4 pb-5" },
									_react2.default.createElement(
										"div",
										{ className: "row  no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h3",
												{ className: _studentsModule2.default.list_title },
												"MSc."
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(_StudentList2.default, { list: alumMsc.edges })
										)
									)
								),
								!alumPhd && !alumMsc && _react2.default.createElement(
									"div",
									{ className: "container mb-5" },
									_react2.default.createElement(
										"div",
										{ className: "row no-gutters justify-content-center" },
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10" },
											_react2.default.createElement(
												"h2",
												{ className: _studentsModule2.default.h2 },
												pageSettings.node_locale === "th" ? "ศิษย์เก่า" : "Alumni"
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "col-12 col-md-10 text-center" },
											_react2.default.createElement(
												"h3",
												{
													className: _studentsModule2.default.list_title
												},
												"Sorry, we haven't added any Alumni yet"
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_CallToAction2.default, {
						className: "my-5",
						text: cta.edges[0].node.content.childMarkdownRemark.html,
						buttonLabel: cta.edges[0].node.buttonLabel,
						destination: "/" + pageSettings.node_locale + cta.edges[0].node.linkTo,
						arrow: true
					}),
					_react2.default.createElement(_studyWithUs2.default, {
						title: workWithUs.title,
						featuredImage: workWithUs.bannerImage,
						description: workWithUs.text.content.html
					})
				)
			);
		};
	
		return Students;
	}(_react2.default.Component);
	
	exports.default = Students;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-students-template-js-622180e823e52eac87ee.js